var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center justify-center flex-col p-32"},[_c('idc-logo',{attrs:{"width":"400","height":"50"}}),_c('p',{staticClass:"text-3xl mt-4 text-gray-800 text-center"},[_vm._v("Trabajando en nuevas características")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }